<app-page pageTitle="Executive Report Categories" [breadcrumbs]="breadcrumbs">
  <div class="exec-report__categories__settings" *ngIf="categoryOrder$ | async as categoryOrder; else isLoading">
    <mat-nav-list class="exec-report-edit__categories__nav-order">
      <mat-progress-bar mode="indeterminate" *ngIf="isReordering$ | async"></mat-progress-bar>
      <ng-container *ngFor="let category of categoryOrder" [ngSwitch]="category">
        <ng-container *ngSwitchCase="categoriesEnum.LISTINGS">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.LISTINGS"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.LISTINGS' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.REPUTATION">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.REPUTATION"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.REPUTATION' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.WEBSITE">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.WEBSITE"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.WEBSITE' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.SOCIAL">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.SOCIAL"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SOCIAL' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.ADVERTISING">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.ADVERTISING"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.ADVERTISING' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.SEO">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.SEO"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SEO' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.CONTENT_AND_EXPERIENCE">
          <mat-list-item
            class="exec-report-edit__categories__list-item"
            draggable="true"
            (dragenter)="dragEnter($event)"
            (dragstart)="dragStart($event)"
            (dragend)="dragEnd($event)"
            [disableRipple]="true"
            [attr.data-category]="categoriesEnum.CONTENT_AND_EXPERIENCE"
          >
            <mat-icon class="grabber" matListItemIcon>drag_handle</mat-icon>
            <span class="category-nav-title">
              {{ 'ADMINISTRATION.EXECUTIVE_REPORT.CONTENT_AND_EXPERIENCE' | translate }}
            </span>
          </mat-list-item>
        </ng-container>
      </ng-container>
    </mat-nav-list>

    <div class="exec-report-edit__categories__report">
      <ng-container *ngFor="let category of categoryOrder" [ngSwitch]="category">
        <ng-container *ngSwitchCase="categoriesEnum.LISTINGS">
          <mat-card appearance="outlined" class="category listings">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.LISTINGS' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.LISTINGS_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.REPUTATION">
          <mat-card appearance="outlined" class="category reputation">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.REPUTATION' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.REPUTATION_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.WEBSITE">
          <mat-card appearance="outlined" class="category website">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.WEBSITE' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.WEBSITE_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.SOCIAL">
          <mat-card appearance="outlined" class="category social">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SOCIAL' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SOCIAL_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.ADVERTISING">
          <mat-card appearance="outlined" class="category advertising">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.ADVERTISING' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.ADVERTISING_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.SEO">
          <mat-card appearance="outlined" class="category seo">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SEO' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.SEO_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
        <ng-container *ngSwitchCase="categoriesEnum.CONTENT_AND_EXPERIENCE">
          <mat-card appearance="outlined" class="category">
            <mat-card-header>
              <mat-card-title>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.CONTENT_AND_EXPERIENCE' | translate }}
              </mat-card-title>
              <mat-card-subtitle>
                {{ 'ADMINISTRATION.EXECUTIVE_REPORT.CONTENT_AND_EXPERIENCE_DESCRIPTION' | translate }}
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <ng-template #isLoading>
    <store-list-stencil [showHeader]="false"></store-list-stencil>
  </ng-template>
</app-page>
